import * as Sentry from '@sentry/vue';
import { version } from '../../package.json';

export function SentrySetup(app, { router, config }) {
  Sentry.init({
    app,
    dsn: 'https://c950d330b61880b6ea8468b682c0da78@sentry.mntr-agent.net/9',
    release: `${config.theme}@${version}`,
    environment: process.env.NODE_ENV,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    denyUrls: [/https?:\/\/([a-zA-Z\-\d]+\.)?intercom\.io/],
    // Tracing
    // tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/api\..*/],
    // Session Replay
    // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // replaysOnErrorSampleRate: 0,
  });
}